<template>
  <section class="center-panel history-fit">
    <div class="tag-title">历史数据拟合</div>
    <div ref="chartRef" class="history-chart"></div>
  </section>
</template>

<script setup>
import * as echarts from "echarts";
import { onBeforeUnmount, onMounted, ref } from "vue";

const chartRef = ref(null);
let chartInstance = null;

function resizeChart() {
  chartInstance && chartInstance.resize();
}

function formatMonthDay(date) {
  const month = `${date.getMonth() + 1}`.padStart(2, "0");
  const day = `${date.getDate()}`.padStart(2, "0");
  return `${month}-${day}`;
}

function getRecentDateLabels() {
  const now = new Date();
  return [132, 103, 74, 45, 18, 2].map((offset) => {
    const date = new Date(now);
    date.setDate(now.getDate() - offset);
    return formatMonthDay(date);
  });
}

onMounted(() => {
  const recentDateLabels = getRecentDateLabels();
  chartInstance = echarts.init(chartRef.value);
  chartInstance.setOption({
    color: ["#5bfff0", "#ffe36a"],
    legend: {
      bottom: 10,
      left: 42,
      itemWidth: 34,
      itemHeight: 8,
      itemGap: 42,
      textStyle: { color: "#eafffd", fontSize: 24, fontWeight: "bold" },
      data: ["近几月单产拟合", "气象修正预测"],
    },
    grid: { top: 110, right: 20, bottom: 120, left: 40 },
    tooltip: {
      trigger: "axis",
      backgroundColor: "rgba(0, 36, 34, 0.94)",
      borderColor: "rgba(74, 255, 238, 0.56)",
      textStyle: { color: "#fff", fontSize: 22 },
      valueFormatter: (value) => `${value} 公斤/亩`,
    },
    xAxis: {
      type: "category",
      data: recentDateLabels,
      axisTick: { show: false },
      axisLine: { lineStyle: { color: "rgba(102,255,238,1.0)" } },
      axisLabel: { color: "#d8fffb", fontSize: 22 },
    },
    yAxis: {
      type: "value",
      min: 0,
      max: 700,
      splitNumber: 7,
      axisLabel: { color: "rgba(235,255,252,.74)", fontSize: 22 },
      axisLine: { show: true, lineStyle: { color: "rgba(102,255,238,1.0)" } },
      axisTick: { show: false },
      splitLine: { lineStyle: { color: "rgba(83,255,237,.15)" } },
    },
    series: [
      {
        name: "近几月单产拟合",
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 9,
        data: [526, 538, 548, 556, 562, 565],
        lineStyle: { width: 4, color: "#5bfff0" },
        itemStyle: { color: "#ffffff", borderColor: "#5bfff0", borderWidth: 3 },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: "rgba(61, 255, 234, 0.44)" },
            { offset: 1, color: "rgba(61, 255, 234, 0.04)" },
          ]),
        },
      },
      {
        name: "气象修正预测",
        type: "line",
        smooth: true,
        symbol: "none",
        data: [518, 532, 544, 553, 563, 568],
        lineStyle: { width: 3, color: "#ffe36a" },
      },
    ],
  });
  window.addEventListener("resize", resizeChart);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", resizeChart);
  chartInstance && chartInstance.dispose();
});
</script>

<style lang="less" scoped>
@import "../shared.less";

.history-fit {
  height: 100%;
  padding: 26px 28px;
}

.history-chart {
  width: 100%;
  height: 100%;
}
</style>
